import React from "react";
import { CompanyLogo } from "../../../styles/component/style";
import { Images } from "../../../assets/images";
import {
  LogoContainer,
  LinksContainer,
  ProfileImage,
  ProfileName,
  LogoutText,
  BigScreen,
  SmallScreen,
  LogoutIcon,
  Row,
  AgentTag,
  HelpIcon,
} from "./Styles";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import styled, { css } from "styled-components";
import COLORS from "../../../assets/Colors";
import useUser from "../../../hooks/useUser";
import { navigate } from "@reach/router";
import labels from "../../../helpers/labels.json";
import useAlert from "../../../hooks/useAlert";
import useSettings from "../../../hooks/useSettings";

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    height: 74,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxShadow: "none",
    borderBottom: "1px solid #e1e3ee",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
}));

export default function StyledAppBar({
  NavPages,
  hideLinks,
  LandingPage,
  onToggleSidebar,
  sidebarOpen,
  showSidebar,
}) {
  const classes = useStyles();
  const { userObject, token, setToken, authSetting } = useUser();
  const { showAlert, hideAlert } = useAlert();
  const { setting, settingsLoading } = useSettings();
  const publicUrl = localStorage.getItem("publicUrl");

  const handleLogout = () =>
    showAlert({
      heading: "Logout?",
      desc: "Are you sure you want to logout?",
      primaryBtnText: "Logout",
      secondaryBtnText: "Cancel",
      clickSecondarybtn: () => hideAlert(),
      clickPrimaryBtn: () => {
        setToken("logged_out");
        hideAlert();
      },
      isOpen: true,
      onDialogClose: () => hideAlert(),
    });

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <LeftGroup>
          {showSidebar && (
            <HamburgerBtn
              onClick={onToggleSidebar}
              title={sidebarOpen ? "Hide sidebar" : "Show sidebar"}
              $open={sidebarOpen}
            >
              <Bar $open={sidebarOpen} $pos="top" />
              <Bar $open={sidebarOpen} $pos="mid" />
              <Bar $open={sidebarOpen} $pos="bot" />
            </HamburgerBtn>
          )}

          <LogoContainer>
            {settingsLoading ? null : (
              <CompanyLogo
                onClick={() =>
                  publicUrl ? navigate(publicUrl) : navigate("/view/cases")
                }
                src={
                  authSetting?.logoUrl || setting?.logoUrl || Images.companyLogo
                }
              />
            )}
          </LogoContainer>
        </LeftGroup>

        <BigScreen>
          <LinksContainer>
            {!token ? (
              <></>
            ) : (
              <>
                {publicUrl ? null : (
                  <Row onClick={() => navigate("/view/help")}>
                    <HelpIcon
                      src={require("../../../assets/images/HelpHeader.svg")}
                    />
                    <ProfileName>{labels["appbar.help"]}</ProfileName>
                  </Row>
                )}
                <Row onClick={handleLogout}>
                  <LogoutIcon
                    src={require("../../../assets/images/logout.svg")}
                  />
                  <LogoutText>{labels["appbar.logout"]}</LogoutText>
                </Row>
                <ProfileImage
                  src={
                    userObject.avatarUrl
                      ? userObject.avatarUrl
                      : require("../../../assets/images/userPlaceholder.svg")
                  }
                />
                <ProfileName onClick={() => navigate("/view/profile")}>
                  <div>{userObject.name}</div>
                  <AgentTag>Neutral</AgentTag>
                </ProfileName>
              </>
            )}
          </LinksContainer>
        </BigScreen>
        <SmallScreen>
          {!token ? null : (
            <>
              <Row onClick={() => navigate("/view/help")}>
                <HelpIcon
                  src={require("../../../assets/images/HelpHeader.svg")}
                />
                <ProfileName>{labels["appbar.help"]}</ProfileName>
              </Row>
              <Row onClick={handleLogout}>
                <LogoutIcon
                  src={require("../../../assets/images/logout.svg")}
                />
                <LogoutText>{labels.logout}</LogoutText>
              </Row>
              <ProfileImage
                src={
                  userObject.avatarUrl
                    ? userObject.avatarUrl
                    : require("../../../assets/images/userPlaceholder.svg")
                }
              />
              <ProfileName>{userObject.name}</ProfileName>
            </>
          )}
        </SmallScreen>
      </Toolbar>
    </AppBar>
  );
}

const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const HamburgerBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #e1e3ee;
  background: ${(p) => (p.$open ? "#f0f4ff" : "#ffffff")};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #f0f4ff;
    border-color: #a5b4fc;
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.15);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const Bar = styled.span`
  display: block;
  height: 2px;
  border-radius: 2px;
  background: #293461;
  transition: all 0.25s ease;

  ${(p) =>
    p.$pos === "top" &&
    css`
      width: ${p.$open ? "16px" : "16px"};
      transform: ${p.$open ? "translateY(7px) rotate(45deg)" : "none"};
    `}

  ${(p) =>
    p.$pos === "mid" &&
    css`
      width: 12px;
      opacity: ${p.$open ? 0 : 1};
      transform: ${p.$open ? "scaleX(0)" : "none"};
    `}

  
  ${(p) =>
    p.$pos === "bot" &&
    css`
      width: ${p.$open ? "16px" : "16px"};
      transform: ${p.$open ? "translateY(-7px) rotate(-45deg)" : "none"};
    `}
`;
